import { BaseService } from '../base';
export class IntegrationResiService extends BaseService {
    constructor() {
        super('integration/resi/playlists');
    }
    async getVideo(id) {
        const response = await this.httpClient.get(`/integration/resi/videos/${id}`);
        return response.data;
    }
}
